export const TypeDraggableBarEnum = Object.freeze({
    none: 'none',
    middle: 'middle',
    min: 'min',
    max: 'max'
})